module.exports = __webpack_public_path__ + "static/media/tablet-icon.80222ced.svg";